import { render, staticRenderFns } from "./EmployeeResourceList.vue?vue&type=template&id=33705625&"
import script from "./EmployeeResourceList.vue?vue&type=script&lang=js&"
export * from "./EmployeeResourceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports